// import { apiClient } from "./client";
// import type { AuthUser, LoginRequest, LoginResponse, RefreshTokenResponse } from "../types/auth";

// interface ApiEnvelope<TData> {
//   data: TData;
// }

// function normalizeUser(user: Omit<AuthUser, "type"> & { type?: "office" | "crew" }): AuthUser {
//   const normalizedType = user.type ?? (user.user_type === "VESSEL" ? "crew" : "office");
//   return {
//     ...user,
//     type: normalizedType,
//     vessel_ids: user.vessel_ids ?? (user.vessel_id !== null ? [user.vessel_id] : []),
//     form_ids: user.form_ids ?? [],
//     process_ids: user.process_ids ?? [],
//   };
// }

// export async function login(payload: LoginRequest): Promise<LoginResponse> {
//   const response = await apiClient.post<ApiEnvelope<Omit<LoginResponse, "user"> & { user: AuthUser }>>(
//     "/psc/auth/login/",
//     payload,
//   );
//   return {
//     ...response.data.data,
//     user: normalizeUser(response.data.data.user),
//   };
// }

// export async function refreshAccessToken(refreshToken: string): Promise<RefreshTokenResponse> {
//   const response = await apiClient.post<ApiEnvelope<RefreshTokenResponse>>(
//     "/psc/auth/refresh/",
//     {
//       refresh: refreshToken,
//     },
//   );
//   return response.data.data;
// }

// export async function logout(refreshToken: string): Promise<void> {
//   await apiClient.post("/psc/auth/logout/", { refresh: refreshToken });
// }

// export async function getCurrentUser(): Promise<AuthUser> {
//   const response = await apiClient.get<ApiEnvelope<AuthUser>>("/psc/auth/me/");
//   return normalizeUser(response.data.data);
// }

//-------------------------------------- version 2 --------------------------------------

import { apiClient } from "./client";
import { refreshSessionTokens } from "./tokenRefresh";
import type { AuthUser, EffectiveVesselAccess, LoginRequest, LoginResponse, RefreshTokenResponse } from "../types/auth";
import type { VesselId } from "../types/vessel";

interface ApiEnvelope<TData> {
  data: TData;
}

function normalizeUser(user: Omit<AuthUser, "type"> & { type?: "office" | "crew" }): AuthUser {
  const normalizedType = user.type ?? (user.user_type === "VESSEL" ? "crew" : "office");
  return {
    ...user,
    type: normalizedType,
    vessel_ids: user.vessel_ids ?? (user.vessel_id !== null ? [user.vessel_id] : []),
    vessels: user.vessels ?? [],
    form_ids: user.form_ids ?? [],
    process_ids: user.process_ids ?? [],
  };
}

export async function login(payload: LoginRequest): Promise<LoginResponse> {
  const response = await apiClient.post<ApiEnvelope<Omit<LoginResponse, "user"> & { user: AuthUser }>>(
    "/psc/auth/login/",
    payload,
  );
  return {
    ...response.data.data,
    user: normalizeUser(response.data.data.user),
  };
}

export async function refreshAccessToken(refreshToken: string): Promise<RefreshTokenResponse> {
  return refreshSessionTokens(refreshToken);
}

export async function logout(refreshToken: string, accessToken?: string | null): Promise<void> {
  await apiClient.post(
    "/psc/auth/logout/",
    { refresh: refreshToken },
    {
      timeout: 5000,
      headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
    },
  );
}

export async function getCurrentUser(): Promise<AuthUser> {
  const response = await apiClient.get<ApiEnvelope<AuthUser>>("/psc/auth/me/");
  return normalizeUser(response.data.data);
}

export async function getEffectiveVesselAccess(vesselId: VesselId): Promise<EffectiveVesselAccess> {
  const response = await apiClient.get<ApiEnvelope<EffectiveVesselAccess>>(
    "/psc/auth/effective-access/",
    { params: { vessel_id: vesselId } },
  );
  return response.data.data;
}
